import { type Writable, writable } from "svelte/store";
import { descending } from "./helpers";
import { User, UserRole, WalletTransaction } from "./walletapi";
import { service } from "./services";
import { RegisterStartupCallback } from "./startup";
// import { GetSessionToken } from "./user";

export const owners = writable<User[]>([]);
export const admins = writable<User[]>([]);
export const cashiers = writable<User[]>([]);
export const players = writable<User[]>([]);

const TOKEN_STORAGE_KEY = "token";
function GetSessionToken() {
const token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
return token ? token : undefined; 
 }


export const roles: UserRole[] = [
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Cashier,
    UserRole.Player
];

export const usersByRole: Record<UserRole, Writable<User[]>> = {
    [UserRole.Owner]: owners,
    [UserRole.Admin]: admins,
    [UserRole.Cashier]: cashiers,
    [UserRole.Player]: players
};

const defaultSort = descending<User>(p => p.Id);

export async function UserListUnassingnedStartup(firstStartup: boolean)
{

    RefreshUsersUnssigned();

    if (!firstStartup)
    {
        // only register operations on first startup
        return;
    }
    service.walletapi.registerOperation("UserChanged", "UnassingnedUser/UserChanged", UserChanged);
    service.walletapi.registerOperation("UserAdded", "UnassingnedUser/UserAdded", UserAdded);
    service.walletapi.registerOperation("NewTransaction", "NewTransaction", NewTransaction);
}

RegisterStartupCallback("UserListStartup", UserListUnassingnedStartup);


export async function RefreshUsersUnssigned()
{
    let userList = await service.walletapi.unassignedUsers({
        Token: GetSessionToken()
    });

    if (!userList.Success)
    {
        // error refreshing
        return;
    }

    for (let role of roles)
    {
        let userListFiltered = userList.Data!.filter(u => u.Role == role);
        usersByRole[role].set(userListFiltered.sort(defaultSort));
    }
}

export function UserAdded(user: User)
{   
    const userList = usersByRole[user.Role];
    userList.update(list => {
        list.push(user);
        return list.sort(defaultSort);
    });
};

export function UserChanged(user: User)
{
    const userList = usersByRole[user.Role];
    
    userList.update(list => {
        let index = list.findIndex(p => p.Id == user.Id);
        if (index == -1)
        {
            // no such user
            return list;
        }

        // copy transaction if exists in old, but not in new
        let oldUser = list[index];
        if (oldUser.LastWalletTransaction &&
            !user.LastWalletTransaction)
        {
            user.LastWalletTransaction = oldUser.LastWalletTransaction;
            user.LastWalletTransaction = oldUser.LastWalletTransaction;
        }
        
        list[index] = user;

        return list;
    });
};

export function NewTransaction(transaction: WalletTransaction)
{   
    // TODO find user no matter the role
    players.update(list => {
        let userIndex = list.findIndex(p => p.Id == transaction.UserId);
        if (userIndex == -1)
        {
            // no such player
            return list;
        }

        list[userIndex] = {
            ...list[userIndex],
            LastWalletTransaction: transaction,
            LastWalletTransactionId: transaction.Id
        };

        return list.sort(defaultSort);
    });
};